module.exports = __webpack_public_path__ + "static/media/Павлов Дмитрий РУБ2017 Человек обязательно должен быть на своей земле хозяином-5.png";